import gql from 'graphql-tag';

const CREATE_DSP_ADVERTISER = gql`
  mutation createDspAdvertiser($input: CreateDspAdvertiserInput!) {
    createDspAdvertiser(input: $input) {
      success
      message
      dspAdvertiserId
      organization {
        id
        name
      }
    }
  }
`;

export default CREATE_DSP_ADVERTISER;